import { getGuestGenderByTitle, isGuestAlreadyInArray } from '@utils/helpers';
import { Guest } from 'shared-types/Basket';
import type { ExistingGuest } from 'voyager';

const toExistingGuest = (guest: Guest): ExistingGuest => ({
  id: String(guest.externalSpaId || guest.id || `${guest.firstName}-${guest.lastName}`),
  name: `${guest.firstName} ${guest.lastName}`,
  title: guest.title || '',
  firstName: guest.firstName,
  lastName: guest.lastName,
  gender: guest.gender || getGuestGenderByTitle(guest.title) || '',
  externalSpaId: guest.externalSpaId,
  guestId: guest.id,
  loggedInUser: guest.loggedInUser,
});

export const buildExistingGuests = (
  basketGuests: Guest[],
  loggedInUser: Guest | null | undefined
): ExistingGuest[] => {
  const existingGuests: ExistingGuest[] = basketGuests.map(toExistingGuest);

  if (
    loggedInUser?.firstName &&
    loggedInUser?.lastName &&
    !isGuestAlreadyInArray(basketGuests, loggedInUser)
  ) {
    existingGuests.unshift(toExistingGuest(loggedInUser));
  }

  return existingGuests;
};
